var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectorEnabled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9057 2.43356H15.7311V0.270395C15.7311 0.121678 15.608 0 15.4575 0H13.5425C13.392 0 13.2689 0.121678 13.2689 0.270395V2.43356H1.09434C0.489033 2.43356 0 2.91689 0 3.51514V21.0908C0 21.6891 0.489033 22.1724 1.09434 22.1724H13.2825V23.254L7.6467 26.9077C7.61674 26.9269 7.59093 26.9518 7.57074 26.981C7.55056 27.0101 7.5364 27.0429 7.52909 27.0774C7.52178 27.112 7.52146 27.1476 7.52814 27.1823C7.53483 27.217 7.54839 27.25 7.56804 27.2795L8.60425 28.8748C8.68632 28.9999 8.85731 29.0371 8.98384 28.956L14.5 25.38L20.0162 28.956C20.1427 29.0371 20.3137 29.0033 20.3958 28.8782L21.432 27.2795C21.4709 27.2198 21.4845 27.1472 21.4698 27.0777C21.4551 27.0081 21.4132 26.947 21.3533 26.9077L15.7311 23.2641V22.1724H27.9057C28.511 22.1724 29 21.6891 29 21.0908V3.51514C29 2.91689 28.511 2.43356 27.9057 2.43356ZM26.5377 19.7389H2.46226V4.86712H26.5377V19.7389Z",
    fill: "#FDF6E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.46226 19.7389H26.5377V4.86712H2.46226V19.7389Z",
    fill: "#F3BB56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectorEnabled);
export default __webpack_public_path__ + "static/media/projector_enabled.331fe2e0d4fd4d2b53e8c3481b9c9caa.svg";
export { ForwardRef as ReactComponent };